<template>
    <v-dialog
        persistent
        :value="value"
        max-width="400"
    >
        <v-card>
            <div class="s-detail-product__header pl-2 pr-2 d-flex align-center">
                <h1 class="app-title">
                    {{indexDetail===-1 ? 'AGREGAR' : 'EDITAR'}}
                </h1>
                <v-spacer></v-spacer>
                <OBtnCardComp
                    icon="mdi-close"
                    @click="$emit('clickclose')"
                />
            </div>
            <div class="client__line-header"></div>
            <div
                v-if="product.id != undefined"
                class="pa-2 pb-1"
            >
                <div class="d-flex">
                    <h1 class="app-title mr-1">Producto:</h1>
                    <h1 class="app-subtitle">
                        {{product.product}}
                    </h1>
                </div>
                <div class="d-flex">
                    <h1 class="app-title mr-1">Tipo Producto:</h1>
                    <h1 class="app-subtitle">
                        {{product.type_product.type_product}}
                    </h1>
                </div>
                <div class="d-flex">
                    <h1 class="app-title mr-1">Laboratorio:</h1>
                    <h1 class="app-subtitle">
                        {{product.laboratory.laboratory}}
                    </h1>
                </div>
            </div>
            <v-divider class="mb-2"></v-divider>
            <v-form
                v-model="valid"
                lazy-validation
                ref="formorder"
                class="pa-2"
                @submit.prevent="eValidForm()"
            >
                <MTextFieldComp
                    label="Cantidad"
                    v-model="product.quantity_order"
                    :rules="[
                        value => !this.mRuleEmptyField(value) || 'La cantidad es requerida',
                        value => this.mRuleNumberInteger(value) || 'La cantidad debe ser un número'
                    ]"
                />
            </v-form>
            <div class="d-flex justify-center pa-2 pt-0">
                <MBtnNormalComp
                    @click="eValidForm()"
                >
                    <v-icon>mdi-bookmark-check</v-icon>
                    GUARDAR
                </MBtnNormalComp>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import {
    MTextFieldComp,
    MBtnNormalComp
} from "../molecules";
import {
    OBtnCardComp
} from "../organisms";
import {
    rulesMixin
} from "../../mixins";
export default {
    mixins: [ rulesMixin ],
    components: {
        OBtnCardComp,
        MTextFieldComp,
        MBtnNormalComp
    },
    props: {
        value: Boolean,
        product: Object,
        indexDetail: Number
    },
    data: () => ({
        valid: true
    }),
    methods: {
        eValidForm() {
            if (this.$refs.formorder.validate())
                this.$emit('saveform', true);
            else this.$emit('saveform', false);
        },
        resetForm() {
            this.$refs.formorder.resetValidation();
        }
    }
}
</script>